// Recipe-decision logic - leidt aanbevolen recipe handle af uit dog-attrs.
// Beslisboom uit sample funnel (clients/wolfork/docs/plans/technisch-voorstel-sample-funnel.md sectie 1).
//
// Input: dog object { lifestage, allergies[], body_shape, eater_type?, pregnant?, nursing? }
// Output: recipe handle string, of null als geen mapping

window.WolforkQuizRecipe = {
  // Mapping naar bestaande recipe metaobject handles
  // (zie metaobjects.recipe.values in admin)
  recommend(dog) {
    if (!dog) return null;

    const allergies = Array.isArray(dog.allergies) ? dog.allergies : [];
    const hasChicken = allergies.includes('chicken');
    const hasBeef = allergies.includes('beef');
    const isObese = dog.body_shape === 'obese' || dog.body_shape === 'overweight';
    const isPregnant = dog.pregnant === true || dog.nursing === true;
    const isPicky = dog.eater_type === 'picky';

    // Drachtig / zogend: aparte recipe
    if (isPregnant) {
      return 'drachtig-zogend-compleet-kipvrij';
    }

    // Puppy: altijd puppy kipvrij (geen rund-variant voor puppy)
    if (dog.lifestage === 'puppy') {
      return 'puppy-compleet-kipvrij';
    }

    // Adult & senior: kipvrij tenzij kieskeurige eter=nee EN kipallergie=nee,
    // dan rundvrij (beslistabel klant, jul 2026). Rundallergie en dieet gaan voor.

    // Senior
    if (dog.lifestage === 'senior') {
      if (hasBeef) return 'senior-compleet-rundvrij';
      if (isObese) return 'senior-compleet-dieet-kipvrij';
      if (hasChicken || isPicky) return 'senior-compleet-kipvrij';
      return 'senior-compleet-rundvrij';
    }

    // Adult (default)
    if (hasBeef) return 'adult-compleet-rundvrij';
    if (isObese) return 'adult-compleet-dieet-kipvrij';
    if (hasChicken || isPicky) return 'adult-compleet-kipvrij';
    return 'adult-compleet-rundvrij';
  },

  // Cybox recipe_number (uit oude voedingsadvies-tool) -> onze recipe metaobject handles.
  // Afgeleid uit geimporteerde customer.metafields.wolfork_quiz.recommended_product_title:
  //   2=Puppy Compleet | Kipvrij, 3=Drachtig & Zogend, 4=Adult Rundvrij, 5=Adult Kipvrij,
  //   6=Adult Dieet Kipvrij, 7=Senior Rundvrij, 8=Senior Kipvrij, 9=Senior Dieet Kipvrij
  cyboxNumberToHandle: {
    2: 'puppy-compleet-kipvrij',
    3: 'drachtig-zogend-compleet-kipvrij',
    4: 'adult-compleet-rundvrij',
    5: 'adult-compleet-kipvrij',
    6: 'adult-compleet-dieet-kipvrij',
    7: 'senior-compleet-rundvrij',
    8: 'senior-compleet-kipvrij',
    9: 'senior-compleet-dieet-kipvrij',
  },

  handleToCyboxNumber: {
    'puppy-compleet-kipvrij': 2,
    'drachtig-zogend-compleet-kipvrij': 3,
    'adult-compleet-rundvrij': 4,
    'adult-compleet-kipvrij': 5,
    'adult-compleet-dieet-kipvrij': 6,
    'senior-compleet-rundvrij': 7,
    'senior-compleet-kipvrij': 8,
    'senior-compleet-dieet-kipvrij': 9,
  },

  // Converteer 1 Cybox dog-object (uit wolfork_quiz.all_dogs JSON) naar onze dog-schema.
  // Cybox velden: dog_name, dog_birth_date (YYYY-MM-DD), dog_weight_kg, dog_gender (male/female),
  // dog_neutered (bool), dog_lifestage (Adult/Puppy/Senior), dog_activity_level (low/medium/high),
  // dog_picky_eater (bool), dog_allergies (array, soms ontbrekend), dog_id (int),
  // recommended: { title, recipe_number, variant_id, bundle_id, color, daily_grams }
  fromCybox(c) {
    if (!c) return null;
    const now = new Date();
    let ageMonths = null;
    if (c.dog_birth_date) {
      const bd = new Date(c.dog_birth_date);
      if (!isNaN(bd)) {
        ageMonths = Math.max(0, Math.round((now - bd) / (1000 * 60 * 60 * 24 * 30.44)));
      }
    }
    const lifestage = (c.dog_lifestage || '').toLowerCase()
      || (ageMonths == null ? 'adult' : (ageMonths < 12 ? 'puppy' : (ageMonths >= 96 ? 'senior' : 'adult')));
    const recipeNumber = c.recommended && c.recommended.recipe_number != null
      ? parseInt(c.recommended.recipe_number, 10)
      : null;
    const recipeHandle = recipeNumber != null ? this.cyboxNumberToHandle[recipeNumber] : null;
    const adh = c.recommended && c.recommended.daily_grams != null
      ? Math.round(parseFloat(c.recommended.daily_grams))
      : null;
    const freq = adh ? Math.round((2100 / adh) * 10) / 10 : null;
    const name = c.dog_name ? c.dog_name.charAt(0).toUpperCase() + c.dog_name.slice(1) : 'Hond';
    return {
      id: c.dog_id ? 'cybox-' + c.dog_id : (crypto.randomUUID ? crypto.randomUUID() : 'cybox-' + Date.now()),
      name: name,
      lifestage: lifestage,
      breed: c.dog_breed || '',
      gender: c.dog_gender === 'female' ? 'teefje' : (c.dog_gender === 'male' ? 'reu' : null),
      current_weight_kg: c.dog_weight_kg != null ? parseFloat(c.dog_weight_kg) : null,
      target_weight_kg: c.dog_weight_kg != null ? parseFloat(c.dog_weight_kg) : null,
      age_months: ageMonths,
      body_shape: c.dog_body_shape || 'ideal',
      activity_level: c.dog_activity_level || 'medium',
      allergies: Array.isArray(c.dog_allergies) ? c.dog_allergies : [],
      spayed: c.dog_neutered === true,
      pregnant: false,
      nursing: false,
      recipe: recipeHandle,
      adh_grams: adh,
      delivery_frequency_days: freq,
      created_at: c.last_quiz_update || new Date().toISOString(),
      source: 'cybox-import',
    };
  },
};
